export default __webpack_public_path__ + "static/media/Wave3.4f6343f9.png";